<template>
  <WsRead
    ref="WsRead"
    localeMode
    :modelName="modelName"
    titleKey="last_version.name"
    :label="label"
    :fields="fields"
    :editable="false"
    :deletable="false"
    :itemEditable="false"
    :fetchUrl="_fetchUrl"
    :id="$route.params.id"
    :itemDeletable="false"
    :multiUrl="$_getMultiUrl"
    :customBtns="_customBtns"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modelVersionName="modelVersionName"
    @input="$_getModelData($event)"
    @goToReview="$_onGoToReview(modelData)"
    @edit-idtf-owners="$_onOpenIdtfOwnersPopup"
    @go-to-related-template="$_onGoToRelatedTemplate(modelData)"
  >
    <WsUpdateDialog
      ref="idtfOwnersPopup"
      customTitle
      label="鑑別人員設定"
      :fields="_idtfOwnersFields"
      @update-submit="$_onSubmitIdtfOwnersPopup"
    />
  </WsRead>
</template>

<script>
import model from '@/models/act_idtf_overall_review';
import idtfModel from '@/models/act_idtf_assignment';
import submodel from '@/models/article';
import S_idtf from '@/services/api/v1/idtf';
import H_idtf from '@/helpers/idtf';

export default {
  data() {
    return {
      modelName: model.modelName,
      modelVersionName: model.versionModelName,
      label: model.label,
      fields: idtfModel.fields,
      modelData: null,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            hideOnNull: false,
            floors: [
              {
                fields: ['locales', 'reference_link', 'attaches'],
              },
            ],
          },
          {
            type: 'expandList',
            label: submodel.label,
            modelName: submodel.versionModelName,
            modeParent: true,
            modeVersions: true,
            modeParentVersions: true,
            fields: submodel.fields.last_version.fields,
            titleKey: 'no_text',
            fieldsRead: ['locales', 'announce_at', 'effect_at', 'attaches', 'effects'],
            batchMode: false,
            searchMode: false,
            orderBy: 'no_number',
            orderWay: 'asc',
            hideOnNull: false,
            isVersionAPI: true,
            itemVersionReadableUrl: (modelData) => `/article/${modelData.article.id}/version`,
            itemCreatable: false,
            getUrl: () => 'article_version/index/light',
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '設定',
                fields: [
                  'sequence',
                  'areas',
                  'act_type',
                  'industry_categories',
                  'system_classes',
                  'system_subclasses',
                  'range_type',
                  'factories',
                  'exclusive_factories',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '鑑別人員設定',
                fields: [
                  'overall_owners',
                  'km_owners',
                  'km_backups',
                  'km_reviewers',
                  'idtf_owners',
                  'idtf_backups',
                  'idtf_reviewers',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '覆核法規鑑別作業狀態',
                fields: [
                  'overall_review_status',
                  'idtf_overall_reviewer',
                  'idtf_overall_reviewed_at',
                ],
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    $_getModelData($event) {
      this.modelData = $event;
    },
    $_onGoToRelatedTemplate(modelData) {
      this.$router.push(
        `/act/${modelData.act_version.act.id}/relatedtemplate/${modelData.act_version.id}`,
      );
    },
    $_onGoToReview() {
      this.$router.push(`/idtf_review_overall/${this.$route.params.id}/review`);
    },
    $_getMultiUrl(modelData) {
      if (!modelData) return [];
      return [`/act/${modelData.act_version.act.id}`, `/act_version/${modelData.act_version.id}`];
    },
    $_onOpenIdtfOwnersPopup() {
      this.$refs.idtfOwnersPopup.open(this.modelData);
    },
    async $_onSubmitIdtfOwnersPopup($event) {
      const popup = this.$refs.idtfOwnersPopup;
      popup.startLoading();
      const { overall_owners, idtf_owners, idtf_backups, idtf_reviewers } = $event;
      const payload = {
        overall_owners,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
      };
      try {
        await S_idtf.update(this.$route.params.id, payload);
      } catch (error) {
        alert(error);
      }
      popup.stopLoading();
      popup.close();
      await this.$refs.WsRead.$_fetchData();
    },
  },
  computed: {
    _customBtns() {
      return H_idtf.setReadPageTopCustomBtns(this.modelData, this.modelName);
    },
    _fetchUrl() {
      return `/act_idtf_assignment/${this.$route.params.id}`;
    },
    _idtfOwnersFields() {
      const { overall_owners, idtf_owners, idtf_backups, idtf_reviewers } = idtfModel.fields;
      return {
        overall_owners,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
      };
    },
  },
};
</script>
